export default {"src":"/_next/static/media/blogCtaBg.24c1a179.svg","height":220,"width":282,"blurWidth":0,"blurHeight":0};